// extracted by mini-css-extract-plugin
module.exports = {"expenseDescription":"style_expenseDescription__1K4La","hidden":"style_hidden__4x2Lc"};